module.exports = "/_next/static/images/preview-4d9d4a55125fcfdc8845e289510b73fd.jpg";